import './Main.css';
import './index.css';
import { createBrowserRouter, RouterProvider, useNavigate, Link } from 'react-router-dom';
import { Spacer, DragNDrop, EmptyElement, BackButton, PageNotFound, Spacer100, Spacer10, Spacer25 } from './Utils';
import strs from './strings';
import legalNoticeStrings from './legalnoticeStrings';
import privacy from './privacyPolicyStrings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faGavel, faLock, faRotateRight } from '@fortawesome/free-solid-svg-icons';

const lang = strs.en;
const ln = legalNoticeStrings.en;
const pp = privacy.en;
const linkColor = '#54C3EA'

export function LegalDocs() {
	const navigate = useNavigate();

	return(
	<div>
		<BackButton />
		<Spacer />
		<h2 className='primary-title'>{lang.legalDocs}</h2>
		<Spacer100 />
		<div className='button-row animated-div'>
			<button className='button-row__large-btn'
				onClick={() => navigate('/legal-notice')}
			>
				<div>
					<FontAwesomeIcon icon={faGavel} className='citizenship-icon round-icon-padding' />
				{lang.legalNotice}
				</div>
			</button>
			<button className='button-row__large-btn'
				onClick={() => navigate('/privacy-policy')}
			>
				<div>
					<FontAwesomeIcon icon={faLock} className='study-icon clipboard-icon-padding' />
				{lang.privacyPolicy}
				</div>
			</button>
			<button className='button-row__large-btn'
				onClick={() => navigate('/terms-of-service-general')}
			>
				<div>
					<FontAwesomeIcon icon={faFileContract} className='live-icon clipboard-icon-padding' />
				{lang.termsofServiceGeneral}
				</div>
			</button>

		</div>
	
	</div>
	);
}

export function LegalNotice() {
	return(
	<div>
		<BackButton />
		<Spacer />
		<h1 className='primary-title centered-text'>{ln.legalNotice}</h1>
		<Spacer100 />
			<div className='center-flex'>
			<div className='document'>
				<div className='p animated-div'>
				<h2 className='secondary-title center-flex'>{ln.generalInfo}</h2>
				<Spacer />
				<p><b>{ln.name}: &nbsp;&nbsp;&nbsp;</b>{ln.nameDatum}</p>
				<p><b>{ln.NIF}: &nbsp;&nbsp;&nbsp;</b>{ln.NIFDatum}</p>
				<p><b>{ln.EUID}: &nbsp;&nbsp;&nbsp;</b>{ln.EUIDDatum}</p>
				<p><b>{ln.address}: &nbsp;&nbsp;&nbsp;</b>{ln.addressDatum}</p>
				<p><b>{ln.phoneNumber}: &nbsp;&nbsp;&nbsp;</b>{ln.phoneNumberDatum}</p>
				<p><b>{ln.email}: &nbsp;&nbsp;&nbsp;</b><Link href='mailto:gdpr@continentalis.eu' className='link'>{pp.emailAddressData}</Link></p>
				<p><b>{ln.registration}: &nbsp;&nbsp;&nbsp;</b>{ln.registrationDatum}</p>
				

				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.intro}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.introText}</p>
				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.users}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.usersTextP0}</p><br/>
				<p className='basic-flex'>{ln.usersTextP1}</p><br />
				<p className='basic-flex'>{ln.usersTextP2}</p>
				
				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.modifications}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.modificationsP0}</p><br/>
				<p className='basic-flex'>
					{ln.modificationsP1A}
					<Link to='/' className='link'>{ln.modificationsLink0}</Link>
					{ln.modificationsP1B}
				</p>
				
				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.conditionsForUse}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.conditionsForUseP0}</p><br/>
				<p className='basic-flex'>{ln.conditionsForUseP1}</p><br />
				<p className='basic-flex'>{ln.conditionsForUseP2}</p><br />
				<p className='basic-flex'>{ln.conditionsForUseP3}</p><br />
				<ul className='basic-flex'>
					{ln.conditionsForUseList.map((item, index) => (
						<li key={index}>{item}</li>
					))}
				</ul>
				<br />
				<p className='basic-flex'>{ln.conditionsForUseP4}</p><br />
				<p className='basic-flex'>{ln.conditionsForUseP5}</p>

				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.notifications}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.notificationsP0}</p><br />
				<ul className='basic-flex'>
					{ln.notificationsList.map((item, index) => (
						<li key={index}>{item}</li>
					))}
				</ul>
				<br />
				<p className='basic-flex'>{ln.notificationsP1}</p>

				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.personalDataProtecton}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.personalDataProtectionP0}</p><br/>
				<p className='basic-flex'>
					{ln.personalDataProtectionP1}
					<Link to='/privacy-policy' className='link'>{ln.personalDataProtectionP1Link0}</Link>.
				</p>
				
				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.intellectualPropertyRights}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.intellectualPropertyRightsP0}</p><br/>
				<p className='basic-flex'>{ln.intellectualPropertyRightsP1}</p>

				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.linksToOtherSites}</h2>
				<Spacer />
				<p className='basic-flex'>{ln.linksToOtherSitesP0}</p>
				
	
				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.disclaimers}</h2>
				<Spacer />
				<p className='basic-flex'>
					{ln.disclaimersP0}
					{<Link href="mailto:ifoundanerror@continentalis.eu" className='link'>ifoundanerror@continentalis.eu</Link>}
				</p>
				<br/>
				<p className='basic-flex'>{ln.disclaimersP1}</p><br/>
				<p className='basic-flex'>{ln.disclaimersP2}</p>

				<Spacer />
				<h2 className='p secondary-title center-flex'>{ln.jurisdiction}</h2>
				<Spacer />
				<p className='basic-flex'>
					{ln.jurisdictionP0}
					<i><b>{ln.jurisdictionP0emph}</b></i>
					{ln.jurisdictionP0cont}
				</p>
				<Spacer />
				<div className='indent'>
					<img src="/joanneSignature.png" />
				</div>
				<Spacer25 />
				<p className='basic-flex indent bold'>{ln.jpoManagingParter}</p>

			<Spacer100 />
				</div>
			</div>
			</div>
	</div>
	);
}


export function PrivacyPolicy() {
	return(
	<div>
		<BackButton />
		<Spacer />
		<h1 className='primary-title centered-text'>{pp.privacyPolicy}</h1>
		<Spacer100 />
			<div className='center-flex'>
			<div className='document'>
				<div className='p animated-div'>

				<h2 className='secondary-title centered-text'>{pp.intro}</h2>
				<Spacer />
				<p className='basic-flex'>
				{pp.introP0}
				<Link to='/legal-notice' className='link'>{pp.introP0Link0}</Link>
				{pp.introP0cont}
				</p><br/>	
				<p className='basic-flex'>
				{pp.introP1}
				<Link to='https://www.boe.es/eli/es/lo/2018/12/05/3/con' className='link'>{pp.introP1Link0}</Link>
				{pp.introP1cont}
				<Link to='http://data.europa.eu/eli/reg/2016/679/2016-05-04' className='link'>{pp.introP1Link1}</Link>
				</p>

				<Spacer />
				<div>
				<h2 className='secondary-title center-flex'>{pp.responsibleParty}</h2>
				<Spacer />
				<p><b>{pp.representative}: &nbsp;&nbsp;&nbsp;</b>{pp.representativeData}</p>
				<p><b>{pp.name}: &nbsp;&nbsp;&nbsp;</b>{pp.nameData}</p>
				<p><b>{pp.NIF}: &nbsp;&nbsp;&nbsp;</b>{pp.NIFData}</p>
				<p><b>{pp.EUID}: &nbsp;&nbsp;&nbsp;</b>{pp.EUIDData}</p>
				<p><b>{pp.address}: &nbsp;&nbsp;&nbsp;</b>{pp.AddressData}</p>
				<p><b>{pp.phoneNumber}: &nbsp;&nbsp;&nbsp;</b>{pp.phoneNumberData}</p>
				<p><b>{pp.emailAddress}: &nbsp;&nbsp;&nbsp;</b><Link href='mailto:gdpr@continentalis.eu' className='link'>{pp.emailAddressData}</Link></p>
				</div>

				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.typesOfData}</h2>
				<Spacer />
				<p className='basic-flex'>{pp.typesOfDataP0}</p>
				<br />
				<ol className='basic-flex'>
					{pp.typesOfDataList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.duration}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.durationList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				<br/>

				<p className='basic-flex'>{pp.durationP0}</p><br />
				<p className='basic-flex'><i>{pp.durationP1}</i></p><br />
				<p className='basic-flex'>{pp.durationP2}</p>
			
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.purposes}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.purposesList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.basis}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.basisList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
			
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.yourRights}</h2>
				<p className='basic-flex'>
					{pp.yourRightsP0Cont0}
					<Link to='https://eur-lex.europa.eu/eli/reg/2016/679/2016-05-04' className='link'>{pp.yourRightsP0Link0}</Link>
					{pp.yourRightsP0Cont1}
					<Link to='https://www.boe.es/eli/es/rd/2007/12/21/1720/con' className='link'>{pp.yourRightsP0Link1}</Link>
					{pp.yourRightsP0Cont2}
				</p>
				<p className='basic-flex'>
					{pp.yourRightsP1Cont0}
					<Link href='mailto:gdpr@continentalis.eu' className='link'>{pp.yourRightsP1Link0}</Link>
					{pp.yourRightsP1Cont1}
				</p><br />
				<p className='basic-flex'>{pp.yourRightsP2}</p><br/>
				<p className='basic-flex'>
					{pp.yourRightsP3Cont0}
					<Link to='https://www.aepd.es/en' className='link'>{pp.yourRightsP3Link0}</Link>
					{pp.yourRightsP3Cont1}
				</p>
			
				<Spacer />
				<div className='indent'>
					<img src="/joanneSignature.png" />
				</div>
				<Spacer25 />
				<p className='basic-flex indent bold'>{ln.jpoManagingParter}</p>
			<Spacer100 />
				</div>
			</div>
			</div>
	</div>
	);
}

export function PrivacyPolicyInitAccount() {
	return(
	<div>
		<Spacer />
		<h1 className='primary-title centered-text'>{pp.privacyPolicy}</h1><br/>
			<div className='center-flex'>
			<div className='document'>
				<div className='p animated-div'>
				<p className='larger-text'><i>(Sorry, this is the last one. Accept button's at the bottom.)</i></p><br />
				<h2 className='secondary-title centered-text'>{pp.intro}</h2>
				<Spacer />
				<p className='basic-flex'>
				{pp.introP0}
				<Link to='/legal-notice' className='link'>{pp.introP0Link0}</Link>
				{pp.introP0cont}
				</p><br/>	
				<p className='basic-flex'>
				{pp.introP1}
				<Link to='https://www.boe.es/eli/es/lo/2018/12/05/3/con' className='link'>{pp.introP1Link0}</Link>
				{pp.introP1cont}
				<Link to='http://data.europa.eu/eli/reg/2016/679/2016-05-04' className='link'>{pp.introP1Link1}</Link>
				</p>

				<Spacer />
				<div>
				<h2 className='secondary-title center-flex'>{pp.responsibleParty}</h2>
				<Spacer />
				<p><b>{pp.representative}: &nbsp;&nbsp;&nbsp;</b>{pp.representativeData}</p>
				<p><b>{pp.name}: &nbsp;&nbsp;&nbsp;</b>{pp.nameData}</p>
				<p><b>{pp.NIF}: &nbsp;&nbsp;&nbsp;</b>{pp.NIFData}</p>
				<p><b>{pp.EUID}: &nbsp;&nbsp;&nbsp;</b>{pp.EUIDData}</p>
				<p><b>{pp.address}: &nbsp;&nbsp;&nbsp;</b>{pp.AddressData}</p>
				<p><b>{pp.phoneNumber}: &nbsp;&nbsp;&nbsp;</b>{pp.phoneNumberData}</p>
				<p><b>{pp.emailAddress}: &nbsp;&nbsp;&nbsp;</b><Link href='mailto:gdpr@continentalis.eu' className='link'>{pp.emailAddressData}</Link></p>
				</div>

				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.typesOfData}</h2>
				<Spacer />
				<p className='basic-flex'>{pp.typesOfDataP0}</p>
				<br />
				<ol className='basic-flex'>
					{pp.typesOfDataList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.duration}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.durationList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				<br/>

				<p className='basic-flex'>{pp.durationP0}</p><br />
				<p className='basic-flex'><i>{pp.durationP1}</i></p><br />
				<p className='basic-flex'>{pp.durationP2}</p>
			
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.purposes}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.purposesList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.basis}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.basisList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
			
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.yourRights}</h2>
				<p className='basic-flex'>
					{pp.yourRightsP0Cont0}
					<Link to='https://eur-lex.europa.eu/eli/reg/2016/679/2016-05-04' className='link'>{pp.yourRightsP0Link0}</Link>
					{pp.yourRightsP0Cont1}
					<Link to='https://www.boe.es/eli/es/rd/2007/12/21/1720/con' className='link'>{pp.yourRightsP0Link1}</Link>
					{pp.yourRightsP0Cont2}
				</p>
				<p className='basic-flex'>
					{pp.yourRightsP1Cont0}
					<Link href='mailto:gdpr@continentalis.eu' className='link'>{pp.yourRightsP1Link0}</Link>
					{pp.yourRightsP1Cont1}
				</p><br />
				<p className='basic-flex'>{pp.yourRightsP2}</p><br/>
				<p className='basic-flex'>
					{pp.yourRightsP3Cont0}
					<Link to='https://www.aepd.es/en' className='link'>{pp.yourRightsP3Link0}</Link>
					{pp.yourRightsP3Cont1}
				</p>
			
				<Spacer />
				<div className='indent'>
					<img src="/joanneSignature.png" />
				</div>
				<Spacer25 />
				<p className='basic-flex indent bold'>{ln.jpoManagingParter}</p>
			<Spacer100 />
				</div>
			</div>
			</div>
	</div>
	);
}


export function TermsAndConditionsGeneral() {
	return(
	<div>
		<BackButton />
		<Spacer />
		<h1 className='primary-title centered-text'>{pp.privacyPolicy}</h1>
		<Spacer100 />
			<div className='center-flex'>
			<div className='document'>
				<div className='p animated-div'>

				<h2 className='secondary-title centered-text'>{pp.intro}</h2>
				<Spacer />
				<p className='basic-flex'>
				{pp.introP0}
				<Link to='/legal-notice' className='link'>{pp.introP0Link0}</Link>
				{pp.introP0cont}
				</p><br/>	
				<p className='basic-flex'>
				{pp.introP1}
				<Link to='https://www.boe.es/eli/es/lo/2018/12/05/3/con' className='link'>{pp.introP1Link0}</Link>
				{pp.introP1cont}
				<Link to='http://data.europa.eu/eli/reg/2016/679/2016-05-04' className='link'>{pp.introP1Link1}</Link>
				</p>

				<Spacer />
				<div>
				<h2 className='secondary-title center-flex'>{pp.responsibleParty}</h2>
				<Spacer />
				<p><b>{pp.representative}: &nbsp;&nbsp;&nbsp;</b>{pp.representativeData}</p>
				<p><b>{pp.name}: &nbsp;&nbsp;&nbsp;</b>{pp.nameData}</p>
				<p><b>{pp.NIF}: &nbsp;&nbsp;&nbsp;</b>{pp.NIFData}</p>
				<p><b>{pp.EUID}: &nbsp;&nbsp;&nbsp;</b>{pp.EUIDData}</p>
				<p><b>{pp.address}: &nbsp;&nbsp;&nbsp;</b>{pp.AddressData}</p>
				<p><b>{pp.phoneNumber}: &nbsp;&nbsp;&nbsp;</b>{pp.phoneNumberData}</p>
				<p><b>{pp.emailAddress}: &nbsp;&nbsp;&nbsp;</b><Link href='mailto:gdpr@continentalis.eu' className='link'>{pp.emailAddressData}</Link></p>
				</div>

				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.typesOfData}</h2>
				<Spacer />
				<p className='basic-flex'>{pp.typesOfDataP0}</p>
				<br />
				<ol className='basic-flex'>
					{pp.typesOfDataList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.duration}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.durationList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				<br/>

				<p className='basic-flex'>{pp.durationP0}</p><br />
				<p className='basic-flex'><i>{pp.durationP1}</i></p><br />
				<p className='basic-flex'>{pp.durationP2}</p>
			
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.purposes}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.purposesList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
				
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.basis}</h2>
				<Spacer />
				<ol className='basic-flex'>
					{pp.basisList.map((item, index) => (
						<div><li key={index}><b>{pp.classificationList[index]}.</b> {item}</li><br /></div>
					))}
				</ol>
			
				<Spacer />
				<h2 className='secondary-title center-flex'>{pp.yourRights}</h2>
				<p className='basic-flex'>
					{pp.yourRightsP0Cont0}
					<Link to='https://eur-lex.europa.eu/eli/reg/2016/679/2016-05-04' className='link'>{pp.yourRightsP0Link0}</Link>
					{pp.yourRightsP0Cont1}
					<Link to='https://www.boe.es/eli/es/rd/2007/12/21/1720/con' className='link'>{pp.yourRightsP0Link1}</Link>
					{pp.yourRightsP0Cont2}
				</p>
				<p className='basic-flex'>
					{pp.yourRightsP1Cont0}
					<Link href='mailto:gdpr@continentalis.eu' className='link'>{pp.yourRightsP1Link0}</Link>
					{pp.yourRightsP1Cont1}
				</p><br />
				<p className='basic-flex'>{pp.yourRightsP2}</p><br/>
				<p className='basic-flex'>
					{pp.yourRightsP3Cont0}
					<Link to='https://www.aepd.es/en' className='link'>{pp.yourRightsP3Link0}</Link>
					{pp.yourRightsP3Cont1}
				</p>
			
				<Spacer />
				<div className='indent'>
					<img src="/joanneSignature.png" />
				</div>
				<Spacer25 />
				<p className='basic-flex indent bold'>{ln.jpoManagingParter}</p>

			<Spacer100 />
				</div>
			</div>
			</div>
	</div>
	);
}

export function TermsOfServiceGeneral() {
	return(
<div>
<BackButton />
<div className='center-flex'>
	<div className='document'>
	<div className='p animated-div'>
	<Spacer />
	<h1 id='title' className='primary-title centered-text'>General Terms of Service</h1>
	<Spacer />
	<p>24 March 2025</p>
	<h1 id="introduction" className='secondary-title center-flex'>0. - Introduction</h1>
	<Spacer />
	<p><i>Hi! Our lawyer with batshit with length but still apparently wanted to sound folksy. Sorry.</i></p><br/>
	<p className='basic-flex'>
		Thanks for using Continentalis App! Before you can start using Continentalis
		App, we have to get some formalities out of the way, starting with these
		General Terms of Service (“General Terms”). We’ve just launched and these
		General Terms are still being polished, but…
	</p><br/>
	<p>
		These General Terms, along with any applicable Additional Terms indicated
		below (collectively, the “Terms”), cover your use and access to the
		products, services, software, platform, and websites (collectively, the
		“Services”) provided by Continental Immigration Services, S.L., and any of
		our affiliates (collectively, “Continentalis”).
	</p><br/>
	<p>
		By using our Services, you agree to be bound by the Terms, by the terms and
		conditions set forth in our Legal Notice and Privacy Policy.
	</p><br/>
	<p>
		If you’re using our Services as the employee or agent of an organization,
		you’re agreeing to the Terms on behalf of said organization.
	</p><br/>
	<p>
		You must be the legal age of majority in your jurisdiction of residence or
		otherwise able to enter into a binding contract with Continentalis in order
		to use the Services. In no event is the use of our Services permitted by
		persons under the age of fourteen (14).
	</p><br/>
	<p>
		In addition to these General Terms, your use of our Services may be governed
		by additional terms and conditions, to which we’ve alluded, such as
		Continentalis’s:
	</p><br/>
	<ul>
		<li>
			<p>Legal Notice</p>
		</li>
		<li>
			<p>Privacy Policy, and</p>
		</li>
		<li>
			<p>Cookie Policy.</p>
		</li>
	</ul>
	<br/>
	<p>
		In addition to the terms and conditions enumerated above, Additional Terms
		shall include any special contracts you enter into with Continentalis
		pertaining to specific Services, whether offered directly on the App Site or
		through other Continentalis channels.
	</p><br/>
	<p>
		In case of conflict between the General Terms and the Additional Terms, then
		the Additional Terms govern in relation to the respective subject matter or
		Service. Certain Services are performed by affiliates or subsidiaries of
		Continental Immigration Services, S.L., where noted in the applicable
		Additional Terms.
	</p><br/>
	<Spacer />
	<h2 id="general-information" className='tertiary-title center-flex'>0.1. - General Information</h2>
	<Spacer />
	<p>
		<strong>Name:</strong> Continental Immigration Services, S.L.,
		(“Continentalis”)
	</p>
	<p>
		<strong>NIF:</strong> B13746680
	</p>
	<p>
		<strong>Address:</strong> Calle de la Princesa 31, 2.º-2, 28008 Madrid,
		Spain
	</p>
	<p>
		<strong>Phone number:</strong> Look at the bottom of the page
	</p>
	<p>
		<strong>Email address:</strong> info@continentalis.eu
	</p>
	<p>
		<strong>Registration Data:</strong> Mercantile Registry of Madrid, T 45.275,
		F 160, S 8, H M-796.481.
	</p>
	<p>
		Continentalis is considered a “commercial entity” (“
		<em>entidad mercantil</em>,” “<em>empresario</em>”) under Spanish law.
	</p>
	<Spacer />

	<h1 id="access-and-use" className='secondary-title center-flex'>1. - Access and use</h1>
	<Spacer />

	<h2 id="eligibility-to-use" className='tertiary-title center-flex'>1.1. - Eligibility to use</h2>
	<Spacer25 />
	<p>
		You have to be at least eighteen (18) years old and be capable of entering
		into a binding agreement to use the Continentalis App. By agreeing to these
		General Terms, you’re warranting and representing that you meet these
		requirements.
	</p>
	<Spacer25 />
	<h3 id="limited-right-to-use" className='quad-title'>1.1.1. - Limited right to use</h3>
	<Spacer25 />
	<p>
		By accepting these General Terms, you’re agreeing to access the Services for
		your personal use and, as the case may be, for your dependent family members
		or Represented Persons, and only as expressly provided in the Terms.
	</p><br/>

	<p>
		You’re not allowed to use the App Site if you’re an attorney, procurator,
		administrative agent (“<em>gestor administrativo</em>”), social graduate,
		immigration consultant, or other similar professional acting in that
		capacity, unless expressly authorized by Continentalis.
	</p><br/>
	<p>
		Violations of these restrictions may result in immediate termination of your
		access to the Services and may result in a claim for damages due to
		infringement.
	</p><br/>
	<h3 id="availability-and-stability" className='quad-title'>1.1.2. - Availability and stability</h3><br/>
	<p>
		Continentalis App is accessible on the WWW at app.continentalis.eu (the “App
		Site”). Like any web-based service, we may have downtime or service
		interruptions. We’ll endeavor to ensure that Continentalis App is up and
		running on the App Site as stably as possible; if we need to interrupt the
		Continentalis App in order to update it, we’ll notify Users ahead of time
		—except for emergencies, at least twenty-four (24) hours ahead of time. You
		agree not to hold us responsible for reasonable downtime and interruptions.
	</p><br/>
	<p>
		Our lawyer wants us to say that his fancy degrees are only good for Spanish
		and European legislation. We don’t know if our Site is in compliance with
		laws where you, the User, are accessing the Site—unless you’re accessing it
		in Spain. If you’re not accessing our Site from within Spain, you may be
		violating the laws of your host state. If accessing our Site is illegal
		where you are, perhaps consider moving. You deserve better. In any case, you
		agree not to hold us liable if accessing the App Site is illegal where you
		live.
	</p><br/>
	<h2 id="modifications" className='tertiary-title center-flex'>1.2. - Modifications</h2><br/>
	<p>
		We reserve the right to modify these Terms, including, but not limited to
		changing, deleting, or supplementing the Terms with Additional Terms
		(collectively, “Changes”) at our sole discretion. We’ll update the Terms in
		their consolidated versions, as well as summaries of Changes to the App
		Site.
	</p><br/>
	<p>
		Make sure to review the Terms on the App Site and on our general site
		—continetnalis.eu— on a regular basis to stay current on our terms and
		conditions. Except where the law requires us to obtain explicit consent,
		your continued use of the App Site and the Services after the Changes take
		effect mean you’ve agreed to the Changes tacitly. You agree not to hold us
		liable to you or anyone else for the Changes.
	</p><br/>
	<h2 id="communications" className='tertiary-title center-flex'>1.3. - Communications</h2><br/>
	<h3 id="communications-generally" className='quad-title'>1.3.1. - Communications generally</h3><br/>
	<p>
		You agree to let us send you communications in connection with Continentalis
		App and the App Site, including, but not limited to, communications
		providing you information related to your Services, notices of official
		communications or notifications related to your active cases ready to be
		accessed, notices of deadlines to accessing official communications or
		notifications related to your active cases, notices of status updates
		related to your active cases, and notices of submission errors or other
		technical incidents related to your active cases or cases pending
		submission, via electronic means, including by e-mail, SMS, in-App Site
		notifications, or push notifications on Continentalis mobile apps
		(collectively, “Communications”).
	</p><br/>
	<p>
		If you agree, we’ll also send you marketing and promotional communications
		regarding Continentalis and our Services, which’ll be included in
		“Communications.” Don’t worry, we won’t bombard you with spam and you can
		opt out of marketing and promotional communications sent to you by
		unsubscribing using the “Unsubscribe” at the bottom of the communication.
	</p><br/>
	<p>
		You agree that Communications satisfy any legal requirements that
		communications be made in writing.
	</p><br/>
	<p>
		We’re acting as an intermediary between government agencies and you:
		<strong> this is serious stuff</strong>. It’s on you to keep your contact
		details current and to check in for Communications on the App Site.
	</p><br/>
	<p>
		If you elect to receive and/or send communications or other messages with
		Continentalis or the App Site by SMS, you confirm that you are the
		subscriber of the mobile service for the mobile number you provide to us or
		that you are otherwise authorized by the subscriber to receive SMS
		communications at said mobile number. You can’t blame us for any issues,
		including, but not limited to failure of delivery, delays in transmission,
		or service outages related to SMS. The costs derived from the use of SMS are
		your responsibility.
	</p><br/>
	<h3 id="communications-regarding-institutional-public-sector-communications-and-notifications" className='quad-title'>
		1.3.2. - Communications regarding Institutional Public Sector communications
		and notifications
	</h3><br/>
	<p>
		The Continentalis App acts as an interface between you and the Government of
		the Kingdom of Spain, a government of a Spanish Autonomous Community, a
		government of a Province, a government of a Municipality in Spain, or any of
		the agencies or organisms pertaining to the aforementioned governments
		(collectively, the “Institutional Public Sector”).
	</p><br/>
	<p>
		During an administrative process underway with an entity of the
		Institutional Public Sector, the entity may send you communications and
		notifications.
	</p><br/>
	<p>
		As a general rule, communications and notifications sent to you by an entity
		of the Institutional Public Sector{" "}
		<strong>must be accessed within ten (10) calendar days</strong> of the
		entity making the communication or notification accessible to you; should
		you not access the communication or notification within the aforementioned
		term, the Institutional Public Sector entity may deem that you have refused
		the communication or notification. Without prejudice to any features of the
		App Site allowing automatic communication and notification access at the end
		of ten days since a communication or notification is made available,
		<strong>
			you agree to access communications and notifications within the
			aforementioned term. You also agree to hold Continentalis blameless if you
			don’t access communications or notifications on time and you’ve not opted
			for us to access these on your behalf on the tenth day.
		</strong>
	</p><br/>
	<p>
		Deadlines to react to certain Institutional Public Sector communications and
		notifications start to run once you have accessed or, as the case may be,
		refused the communication or notification.
	</p><br/>
	<p>
		General rules are superseded by special rules applicable to specific
		administrative procedures. Talk to a lawyer to determine the deadlines
		applicable to your procedure.
	</p><br/>
	<h1 id="ownership" className='secondary-title center-flex'>2. - Ownership</h1>
	<Spacer25 />
	<h2 id="intellectual-property" className='tertiary-title center-flex'>2.1. - Intellectual property</h2><br/>
	<p>Refer to “Intellectual Property Rights” on our Legal Notice.</p><br/>
	<h2 id="downloadable-content" className='tertiary-title center-flex'>2.2. - Downloadable content</h2><br/>
	<p>
		Continentalis may make certain digital assets available for download in PDF,
		DOCX, EPUB, or other formats. Except as expressly agreed in writing, making
		these digital assets available for download does not constitute granting,
		conveying, transferring, or assigning rights to the digital assets. You
		agree to use the digital assets only as intended —and as indicated in each
		digital asset or its hosting page— and never for commercial or professional
		purposes. Continentalis reserves the right to seek civil and/or criminal
		remedies for unauthorized use of its digital assets.
	</p><br/>
	<h2 id="user-submitted-content" className="tertiary-title center-flex">2.3. - User-Submitted Content</h2><br />
	<h3 id="submissions" className='quad-title'>2.3.1. - Submissions</h3><br/>
	<p>
		The App Site may enable you to submit, post, upload, or otherwise make
		available content such as questions, public messages, ideas, product
		feedback,comments, and other content (collectively, “User-Submitted
		Content”).
	</p><br/>
	<p>
		Except as expressly agreed in writing, you grant us a nonexclusive,
		royalty-free, and fully sublicensable right to access, view, use, reproduce,
		adapt, public, translate, create derivative works from, distribute, copy,
		and display your User-Submitted Content throughout the world in any form,
		medium, or technology now known or later developed. You represent and
		warrant that: (a) you own or otherwise control all of the rights to the
		User-Submitted Content; (b) your User-Submitted Content is truthful and
		accurate; and (c) the User-Submitted Content does not infringe the Terms or
		any applicable legislation.
	</p><br/>
	<p>
		Use-Submitted Content shall not be construed to include the User’s personal
		documents, such as, but not limited to, passports and other identification
		documents, birth certificates, marriage certificates, business plans,
		financial statements, photographs, or other user-generated documents
		uploaded to the User’s documents repository or to the User’s cases, or any
		documents generated by the Continentalis App account environment.
	</p><br/>
	<h3 id="screening-and-removal" className='quad-title'>2.3.2. - Screening and removal</h3><br/>
	<p>
		You agree that Continentalis may, at our sole discretion, pre-screen or
		remove User-Submitted Content, but that we have no obligation to do so.
		Continentalis reserves the right to remove any User-Submitted Content that
		violates the Terms or is objectionable in our sole discretion.
	</p><br/>
	<h1 id="restrictions" className='secondary-title center-flex'>3. - Restrictions</h1>
	<Spacer25 />
	<p>
		By using the App Site, you specifically agree not to, and to not permit
		others to, engage in, or attempt to engage in, any activity or transmit any
		information that, in our sole discretion:
	</p><br/>
	<ol type={1}>
		<li>
			<p>
				Violates any law or regulation applicable in the Kingdom of Spain and in
				your place of residence therein, or, in lieu thereof, applicable in
				Madrid;
			</p>
		</li>
		<li>
			<p>
				Advocates illegal activity or discusses illegal activity with the intent
				to commit said illegal activity;
			</p>
		</li>
		<li>
			<p>
				Violates Continentalis and any third-party rights, including, but not
				limited to, rights of privacy, publicity, copyright, trademark, patent,
				or trade secret;
			</p>
		</li>
		<li>
			<p>
				Is threatening, abusive, harassing, tortious, indecent, defamatory,
				sexually explicit or pornographic, discriminatory, vulgar, profane,
				obscene, libelous, constitutive of hate speech, violent, inflammatory,
				or otherwise objectionable;
			</p>
		</li>
		<li>
			<p>Interferes with any other person’s use of the App Site;</p>
		</li>
		<li>
			<p>Attempts to impersonate another person or entity;</p>
		</li>
		<li>
			<p>
				Falsely states, misrepresents, or conceals your affiliation with another
				person or entity;
			</p>
		</li>
		<li>
			<p>
				Distributes computer viruses or other malicious code, files, or programs
				which interrupt, destroy, or limit the functionality of any computer
				software or hardware or electronic communications equipment;
			</p>
		</li>
		<li>
			<p>
				Interferes with, disrupts, or disables the functionality or use of the
				App Site or any of its features;
			</p>
		</li>
		<li>
			<p>
				Hacks or accesses without authorization any feature or area of the App
				Site, especially, but not limited to, the account areas of any other
				User;
			</p>
		</li>
		<li>
			<p>
				Decompiles, reverse engineers, disassembles, or otherwise attempts to
				derive source code from the App Site, except as expressly permitted by
				the Terms or by law or by express written consent from Continentalis;
			</p>
		</li>
		<li>
			<p>
				Removes, disables, damages, circumvents, or otherwise interferes with
				security features of, or features that enforce limitations on, the App
				Site;
			</p>
		</li>
		<li>
			<p>
				Constitutes “screen scraping,” “database scraping,” or any other such
				activity with the purpose of obtaining lists of Users or other
				information;
			</p>
		</li>
		<li>
			<p>
				Downloads, distributes, posts, transmits, reproduces, broadcasts,
				duplicates, or otherwise uses Continentalis’s intellectual property
				except as expressly authorized; or
			</p>
		</li>
		<li>
			<p>
				Uses, or allows third parties to use, the App Site’s front-end and
				back-end contents, architectures, etc., to directly or indirectly
				create, train, test, implement, or otherwise feed any machine learning
				algorithm or artificial intelligence system except as expressly
				authorized by Continentalis.
			</p>
		</li>
	</ol>
	<br/>
	<p>Remember, be a good User.</p><br/>	
	<h1 id="usage-and-access-rights" className='secondary-title center-flex'>4. - Usage and access rights</h1>
	<Spacer25 />
	<h2 id="right-to-use-services" className='tertiary-title center-flex'>4.1. - Right to use Services</h2><br/>
	<p>
		Subject to these Terms, you have a limited, non-exclusive, non-transferable
		right and license during the Term to:
	</p><br/>
	<ol type="a">
		<li>
			<p>Use the Services you have purchased from Continentalis;</p>
		</li>
		<li>
			<p>
				Implement, configure, access, and use the Services you have purchased up
				to any applicable limits set forth in your specific Service
				agreement(s); and
			</p>
		</li>
		<li>
			<p>
				Access and use guides, samples, and similar digital assets made
				available for view or download on the App Site, solely for the purposes
				of learning about the App Site and the Services which you have
				purchased.
			</p>
		</li>
	</ol><br/>
	<p>
		Violation by you, or by anyone in use of your account, of the license
		provisions contained in this Section may result in the immediate termination
		of your right to use the Services, as well as potential civil and/or
		criminal liability.
	</p><br/>
	<h2 id="user-obligations" className='tertiary-title center-flex'>4.2. - User obligations</h2><br/>
	<p>
		Users are responsible for all use of the Services associated with their
		respective accounts. Users are solely responsible for maintaining
		confidentiality of their respective account usernames and passwords. Users
		agree to immediately notify Continentalis of any unauthorized access or use
		of the User’s respective account. Users agree to hold Continentalis
		blameless for any losses incurred as a result of other Users’ accounts,
		except to the extent that such liability cannot be lawfully excluded under
		applicable law.
	</p><br/>
	<h2 id="user-representation" className='tertiary-title center-flex'>4.3. - User representation</h2><br/>
	<p>
		Users may use the contracted Services in representation of other natural
		persons, provided said Users act in legal representation, curatorship, or a
		similar relationship with the other natural persons (“Represented Persons”).
		“Legal representation” shall mean representation established in law, as for
		parents, guardians, or, in civil law jurisdictions, tutors; “legal
		representation” shall not mean representation established in a power of
		attorney or mandate.
	</p><br/>
	<Spacer25 />
	<h1 id="payment-terms" className="secondary-title center-flex">5. - Payment terms</h1>
	<Spacer25 />
	<h2 id="service-fees" className='tertiary-title center-flex'>5.1. - Service fees</h2><br/>
	<p>
		The Services offered on Continentalis App are subject to payment of service
		fees, as set forth and quantified in each Service’s specific terms and
		conditions.
	</p><br/>
	<p>
		Continentalis reserves the right to modify service fees at any time.
		Purchases made prior to such modifications in service fees shall not be
		affected by said modifications.
	</p><br/>
	<h2 id="administrative-fees" className='tertiary-title center-flex'>5.2. - Administrative Fees</h2><br/>
	<h3 id="applicability-of-administrative-fees" className='quad-title'>
		5.2.1. - Applicability of Administrative Fees
	</h3><br/>
	<p>
		Certain administrative procedures require payment of administrative fees
		(referred to in Spanish as “<em>tasas administrativas</em>”) or rates
		(referred to in Spanish as “<em>tarifas</em>”) (collectively,
		“Administrative Fees”). In some cases, payment of Administrative Fees must
		be made <strong>prior</strong> to submission of an administrative
		application or petition; in other cases, payment of Administrative Fees may
		be made at a later date.
	</p><br/>
	<p>
		If you don’t pay Administrative Fees, the government may bar submission of
		your application or petition, or they may dismiss or deny your application
		or petition, or the government may carry out administrative actions
		requiring payment, and even exacting payment, of Administrative Fees,
		potentially causing delays in processing and generating additional costs.
	</p><br/>
	<h3 id="payment-of-administrative-fees-in-representation" className='quad-title'>
		5.2.2. - Payment of Administrative Fees in representation
	</h3><br/>
	<p>
		In some cases, we may be able to pay Administrative Fees on your behalf.
		We’ll make this option available where the government allows it. In these
		cases, before we pay the Administrative Fee on your behalf, we’ll require
		that you provide us the funds needed to pay the Administrative Fee, plus a
		5% surcharge to account for effort exerted and costs incurred by
		Continentalis.
	</p><br/>
	<p>
		If you elect to have us pay Administrative Fees on your behalf, or on your
		Represented Persons’ behalf, it’s on you to provide us correct information,
		including, but not limited to, procedure time,
		<em>justificante</em> number if you already have one, the creditor agency,
		the debtor, etc., so that we can generate an adequate payment form. You
		agree not to hold us liable for errors in the information you provide for
		this service.
	</p><br/>
	<p>
		Our system will attempt to pay the Administrative Fee as soon as you’ve
		authorized it to. Once paid, you won’t be able to ask us for a refund. If a
		refund is desired, you’ll need to request a refund from the appropriate
		State agency. The 5% surcharge is not refundable, as it covers immediate
		work and costs.
	</p><br/>
	<h2 id="promotional-codes" className='tertiary-title center-flex'>5.3. - Promotional codes</h2><br/>
	<p>
		We may, from time to time, offer promotional codes for use with a Service.
		These codes are only valid for initial engagements of the specific Service
		—e.g., for your first “Modification from Student Stay to Residence and
		Self-Employment” pack— unless otherwise specified. By “your” first, we
		really mean “your” first: we’ll use your NIE and biographical information to
		ensure that you’re not double-dipping. Be a good User.
	</p><br/>
	<h2 id="refunds" className='tertiary-title center-flex'>5.4. - Refunds</h2><br/>
	<p>
		You acknowledge and agree that payments are non-refundable except as
		expressly provided in these Terms or as otherwise agreed to in writing by
		Continentalis or as required by applicable legislation. Charges for Services
		and for payment of Administrative Fees will be billed to the User in
		advance.
	</p><br/>
	<Spacer25 />
	<h1 id="administrative-representation" className='secondary-title center-flex'>6. Administrative representation</h1>
	<Spacer25 />
	<h2 id="capacity" className='tertiary-title center-flex'>6.1. - Capacity</h2><br/>
	<p>
		The User warrants and represents that the User possesses sufficient capacity
		to enter into administrative procedures pursuant to Law 39/2015, of 1
		October, on the Common Administrative Procedure of the Public
		Administrations (“LCAPPA”).
	</p><br/>
	<p>
		The User warrants that they are entering into administrative procedures on
		their own behalf or on behalf of their Represented Persons in accordance
		with the provisions of LCAPPA.
	</p><br/>
	<p>
		The User agrees that they, or their legal representatives, curators, or, in
		civil law jurisdictions, tutors, will notify Continentalis of any changes to
		the User’s, or the User’s Represented Persons’, capacity within ten (10)
		calendar days of the change.
	</p><br/>
	<h2 id="representation" className='tertiary-title center-flex'>6.2. - Representation</h2><br/>
	<p>
		The User acknowledges that Continentalis has informed them that LCAPPA
		authorizes interested parties to engage in administrative procedures on
		behalf and in representation of third parties (“Administrative
		Representation”), and that Administrative Representation is voluntary for
		persons with capacity.
	</p><br/>
	<h3 id="powers-of-administrative-representation" className='quad-title'>
		6.2.1. - Powers of Administrative Representation
	</h3><br/>
	<p>
		In accordance with LCAPPA, Administrative Representation requires issuance
		of Powers of Administrative Representation in a public document or in a
		document signed with a recognized digital signature and recorded with the
		Government of Spain’s Electronic Registry of Powers (“
		<em>Registro Electrónico de Apoderamientos</em>”).
	</p><br/>
	<p>
		The User acknowledges that the correct performance of the Terms by
		Continentalis and its affiliates requires Powers of Administrative
		Representation and, therefore, warrants and represents as follows:
	</p><br/>
	<ol type="a">
		<li>
			<p>
				That the User grants Continentalis and its attorney, procurator,
				administrative agent, social graduate, and other agents, at
				Continentalis’s discretion,{" "}
				<strong>
					general powers of administrative representation for any administrative
					procedure before any public administration or other Institutional
					Public Sector entity
				</strong>
				;
			</p>
		</li>
		<li>
			<p>
				That the duration of the User’s grant of power of Administrative
				Representation shall be for the period selected by the User, to be at
				least <strong>six (6) months</strong> from the date of issuance;
			</p>
		</li>
		<li>
			<p>
				That the default duration of the User’s grant of power of Administrative
				Representation, in lieu of a duration specified by the User, shall be
				the statutorily-established period of five (5) years from the date of
				issuance;
			</p>
		</li>
		<li>
			<p>
				That Continentalis and its attorney, procurator, administrative agent,
				social graduate, and other agent affiliates may renounce representation
				in accordance with these Terms; and
			</p>
		</li>
		<li>
			<p>
				That the User shall sign a qualified power of Administrative
				Representation within five (5) business days from such date as
				Continentalis shall require the User to that effect.
			</p>
		</li>
	</ol><br/>
	<p>
		Each Service pack’s Service Fees purchased through Continentalis App shall
		include the electronic signing of a qualified power of attorney for
		recording with the Electronic Registry of Powers through Continentalis’s
		third-party identity certifiers of choice. The User must provide correct
		personal details and identifying documents for the drawing up of the power
		of attorney.{" "}
		<strong>
			If the User has an active power of Administrative Representation already
			in place and at least six (6) months remain in its validity, this
			provision shall not apply; where an administrative term established for a
			new case exceeds the duration of the User’s active power of attorney, the
			provision shall apply.
		</strong>
	</p><br/>
	<p>
		Fees for notarial powers of Administrative Representation shall not be
		deemed included in the Service Fees.
	</p><br/>
	<h3 id="presumed-administrative-representation" className='quad-title'>
		6.2.2. - Presumed Administrative Representation
	</h3><br/>
	<p>
		Certain procedures, such as immigration applications filed with Delegations
		and Subdelegations of the Government, as well as citizenship applications
		filed through the various Colleges of Attorneys, benefit from presumed
		Administrative Representation.
	</p><br/>
	<p>
		The User hereby requests that Continentalis default to presumed
		Administrative Representation where possible, by filing applications and
		petitions through qualified attorney, procurator, administrative agent, or
		social graduate selected at Continentalis’s sole discretion from
		Continentalis’s pool of Qualified Representatives.
	</p><br/>
	<p>
		The User warrants and represents that they are aware that, despite the
		presumption of Administrative Representation here described, public
		administrations and other Institutional Public Sector entities may, in
		exceptional and reasoned writs, demand proof of issuance of powers of
		Administrative Representation. In such cases, the User agrees to act in
		accordance with section 7.2.1.
	</p><br/>
	<h3 id="qualified-representatives" className='quad-title'>6.2.3. - Qualified Representatives</h3><br/>
	<p>
		Continentalis will maintain a pool of attorneys, procurators, administrative
		agents, and/or social graduates who have been authorized to represent
		natural or legal persons in administrative parties in accordance with
		article 5.7 LCAPPA (“Qualified Representative(s)”).
	</p><br/>
	<p>
		The User expressly authorizes Continentalis to, where possible, file the
		User’s applications through a Qualified Representative from the
		aforementioned pool, to be selected at Continentalis’s sole discretion.
	</p><br/>
	<h3 id="obligations-and-limitations-as-to-qualified-representatives" className='quad-title'>
		6.2.4. - Obligations and limitations as to Qualified Representatives
	</h3><br/>
	<p>
		In filing through a Qualified Representative, the User warrants and
		represents that the documents and information provided by the User in the
		relevant case are true and correct to the best of the User’s knowledge. The
		User further acknowledges that misrepresentations by the User and filing
		frivolous cases may result in administrative or professional actions against
		the Qualified Representative, including, but not limited to, removal from
		the public administrations’ and Institutional Private Sector entities’ rolls
		of qualified representatives. In the event that a Qualified Representative
		is sanctioned in the terms set forth in this paragraph due to
		misrepresentations by the User or due to filing of frivolous cases by the
		User, the User shall be liable to the Qualified Representative in an amount
		equal to the harms caused to the Qualified Representative, or five hundred
		euros (500€), whichever is greater.{" "}
		<strong>
			Be a good User: don’t have our Qualified Representatives struck off.
		</strong>
	</p><br/>
	<p>
		You alone are responsible for the accuracy, validity, and veracity of the
		data and documents lodged in any given administrative procedure filed using
		Continentalis App. Continentalis’s Qualified Representatives make no
		warranty of accuracy, validity, or veracity.
	</p><br/>
	<p>
		Administrative Representation in accordance with article 5.7 LCAPPA, in
		accordance with governing agreements between public administrations and
		professional associations, and in accordance with the Terms
		<strong>
			do not constitute an attorney-client, or other professional-client
			relationship between the User and the Qualified Representative, and do not
			constitute an obligation by the Qualified Representative to provide the
			User with legal advice.
		</strong>{" "}
		Without prejudice to the foregoing, privilege applies.
	</p><br/>
	<Spacer25/>
	<h1 id="personal-data-protection" className='secondary-title center-flex'>7. Personal Data Protection</h1>
	<Spacer25 />
	<p>
		You acknowledge your understanding and hereby provide consent that the
		information you provide to us or that we will collect will be processed as
		described in our Privacy Policy, available here:{" "}
		<a href="https://continentalis.eu/privacy-policy/">
			<u>https://continentalis.eu/privacy-policy/</u>
		</a>
		.
	</p><br/>
	<Spacer />

	<h1 id="confidentiality" className='secondary-title center-flex'>8. Confidentiality</h1>
	<Spacer/>
	<h2 id="scope" className='tertiary-title center-flex'>8.1. - Scope</h2><br/>
	<p>“Confidential Information” means:</p><br/>
	<ol type="a">
		<li>
			<p>
				Any written information, materials, and other documents supplied by
				Continentalis related to the App Site which we do not generally disclose
				publicly;
			</p>
		</li>
		<li>
			<p>
				Any written information, materials, and other documents supplied by you
				in relation to the Services;
			</p>
		</li>
		<li>
			<p>
				Any documents generated through the App Site for use in relation with
				the Services;
			</p>
		</li>
		<li>
			<p>
				Any Communications, except promotional and marketing Communications,
				sent to you by Continentalis in accordance with these Terms; and
			</p>
		</li>
		<li>
			<p>
				In general, any information which, by its nature, is deemed to be
				confidential <strong>and</strong> comes to be known by Continentalis by
				way of the Services.
			</p>
		</li>
	</ol><br/>
	<h2 id="restricted-use-and-professional-secrecy">
		8.2. - Restricted use and professional secrecy
	</h2><br/>
	<p>
		Continentalis shall, to the best of its ability, and to the extent required
		by applicable law, guarantee the security of Confidential Information on its
		servers, platform, website, etc.
	</p><br/>
	<p>
		Continentalis’s security measures are only as strong as the weakest element
		in the measures. To that end, the User agrees:
	</p><br/>
	<ol type="a">
		<li>
			<p>
				To establish a strong password in accordance with the password policy
				which shall be communicated on the App Site;
			</p>
		</li>
		<li>
			<p>To secure their passwords in accordance with good practices;</p>
		</li>
		<li>
			<p>To sign into their account only on trusted devices;</p>
		</li>
		<li>
			<p>
				To not leave their account open on any devices other than their own; and
			</p>
		</li>
		<li>
			<p>
				In general, to treat their account and documents uploaded thereto with
				care.
			</p>
		</li>
	</ol><br/>
	<p>
		Even where professional privilege —e.g., attorney-client privilege— is not
		in effect, Continentalis is subject to professional secrecy. Professional
		secrecy means that Continentalis cannot disclose your Confidential
		Information to any party, including, but not limited to, law enforcement
		agencies, courts, or administrative agencies, without your consent or
		without compulsory orders made in accordance with legislation.
	</p><br/>
	<h3 id="required-disclosure" className='quad-title'>8.2.1. - Required disclosure</h3><br/>
	<p>
		To the fullest extent possible, Continentalis shall reject any requests to
		access any Confidential Information by third parties. Except as expressly
		forbidden by law, we will notify you of any and all requests to access your
		Confidential Information made by State actors
		<strong>prior to</strong> complying, where applicable, with said requests.
	</p><br/>
	<p>
		Continentalis is not a law-enforcement agency-friendly company. We will not
		comply with requests to access Confidential Information where the law does
		not require us to.
	</p><br/>
	<Spacer />
	<h1 id="term-and-termination" className="secondary-title center-flex">9. Term and Termination</h1>
	<Spacer />
	<h2 id="term" className='tertiary-title center-flex'>9.1. - Term</h2><br/>
	<p>
		These Terms, together with any Changes, are effective as of your acceptance
		thereof and until your use of the Services ceases or until your account has
		been deleted either by you or by Continentalis in accordance with the Terms
		(“Term”).
	</p><br/>
	<h2 id="termination-by-user" className='tertiary-title center-flex'>9.2. - Termination by User</h2><br/>
	<p>
		You may terminate your account at any time. If you wish to terminate, you
		must provide notice, as we may instruct on the App Site, on Continentalis’s
		website, or by written notification to Continentalis pursuant to our Legal
		Notice. Requests for termination made in writing, rather than through
		automated processes, may take up to ten (10) calendar days from receipt
		thereof to be processed.
	</p><br/>
	<p>
		You agree to update your or your Represented Persons’ contact information in
		the relevant account areas{" "}
		<strong>
			prior to requesting termination of your or your Represented Persons’
			accounts.
		</strong>{" "}
		You agree to hold Continentalis blameless for your omission of this
		obligation.
	</p><br/>
	<h2 id="effects-of-termination" className='tertiary-title center-flex'>9.3. - Effects of termination</h2><br/>
	<p>
		Upon termination, Continentalis and any of its affiliated attorneys,
		procurators, administrative agents, social graduates, or other collaborators
		as set forth in the Terms and, specifically, in the special terms and
		conditions for each Service, shall, within one business day,{" "}
		<strong>
			notify withdrawal of representation to the relevant Institutional Public
			Sector entity
		</strong>
		, and provide your or your Represented Persons’ contact information as
		listed in the User account area.
	</p><br/>
	<p>
		Termination while administrative procedures are ongoing may cause issues
		with your or your Represented Persons’ open cases, including, but not
		limited to, communications and notifications by Institutional Public Sector
		being sent to Continentalis and its affiliates or being published to the
		Official Bulletin of the State, mailed to your last known address, or mailed
		to the address listed on your Spanish ID, among others. You are solely
		responsible for providing an alternative mode of notification for future
		official communications and notifications regarding ongoing cases at the
		time of termination. You agree to hold Continentalis blameless for improper
		conveyance of communications or notifications by Institutional Public Sector
		entities after Continentalis has withdrawn representation.
	</p><br/>
	<p>Upon termination:</p><br/>
	<ol type="a">
		<li>
			<p>
				Any and all liabilities the User has accrued before the termination will
				survive;
			</p>
		</li>
		<li>
			<p>
				Any licenses and use rights granted to the User will immediately cease
				in accordance with these Terms; and
			</p>
		</li>
		<li>
			<p>
				Any obligations for Continentalis to provide further access to the App
				Site to the User shall terminate, except any such rights as are
				expressly provided in the Terms or in applicable legislation.
			</p>
		</li>
	</ol><br/>

		<Spacer />
	<h1 id="right-to-withdraw" className='secondary-title center-flex'>10. Right to Withdraw</h1>
		<Spacer />
	<p>
		In accordance with Spanish and European Union legislation, the User shall be
		able to withdraw from the Terms applicable to each Service engaged within{" "}
		<strong>fourteen (14) calendar days of purchase</strong>
		(“Withdrawal Period”), without needing to indicate the reason for withdrawal
		and without incurring any costs other than costs for expediting any aspect
		of the Service (“Right to Withdraw”).
	</p><br/>
	<p>
		You may not exercise this Right to Withdraw once you’ve accessed the Service
		and consented to starting its performance. (You’ll know: any time you create
		a new case, you’ll be required to pay a Service Fee and, subsequently, start
		the case).
	</p><br/>
	<p>
		In order to exercise their Right to Withdraw with regard to any particular
		Service purchased through Continentalis App,{" "}
		<strong>the User must communicate to Continentalis</strong> their clear and
		unequivocal wish to withdraw from the Service within the Withdrawal Period.
		Notifications for exercise of the Right to Withdraw shall be made in writing
		to{" "}
		<a href="mailto:info@continentalis.eu">
			<u>info@continentalis.eu</u>
		</a>{" "}
		and must include your username and your invoice number or Service ID.
		<strong>
			<u>Never</u>
		</strong>{" "}
		include your password in these communications. If we need additional
		information in order to verify your identity or clear up any questions
		regarding your wish to withdraw, we will contact you; the withdrawal request
		will be considered made on the day of notification, not the day on which we
		clear up any doubts.
	</p><br/>
		<Spacer/>

	<h1 id="warranties-and-disclaimers" className='secondary-title center-flex'>11. Warranties and disclaimers</h1><br/>
	<p>
		The Continentalis App and the App Site and any information we supply you are
		provided “as is” and “as available.” We’ve done our best to ensure that
		everything’s correct. We’ve consulted with Melcart Abogados on the
		legalities of each procedure. Nevertheless, you assume the risks of using
		the App Site. When in doubt about a document, requirement, etc., consult
		with a lawyer.
	</p><br/>
	<p>
		Continentalis is not a law firm. The information on Continentalis’s website
		and on the App Site should not be construed as legal advice.
		<strong>
			Consult with a lawyer wherever you have questions regarding deadlines,
			requirements, interpretations, etc.
		</strong>
	</p><br/>
				<Spacer />
				<div className='indent'>
					<img src="/joanneSignature.png" />
				</div>
				<Spacer25 />
				<p className='basic-flex indent bold'>{ln.jpoManagingParter}</p>
			<Spacer100 />
				</div>

</div>
</div></div>
	);
}

export function TermsOfServiceServicePack() {
	return(
<div>
	<BackButton />
	<Spacer />
	<h1 className='primary-title centered-text'>Special Terms of Service</h1>
	<Spacer />
	<h2 className='tertiary-title center-flex'>For a “Urgent Modification from Student Stay to Residence and Self-Employment (E-HI-66)” service pack.</h2>
	<Spacer />
	<div className='center-flex'>
	<div className='document'>
	<div className='p animated-div'>

	<p>24 March 2025</p>
	<h1 id="introduction" className='secondary-title center-flex'>0. - Introduction</h1>
	<Spacer/>
	<p>Hi!</p><br/>
	<p>
		Thanks for purchasing this "Modification from Student Stay to Residence and
		Self-Employment (E-HI-66)” service pack.
	</p><br/>
	<p>
		This service pack is intended for you to apply for modification from the
		status of authorization for stay for the purposes of studies to the status
		of authorization for residence and self employment
		<strong>pursuant to article 199 of Royal Decree 557/201</strong>, that is,
		prior toentry into force of Royal Decree 1155/2024 on 20 May 2025. This
		service pack will allow you to build a case file with your personal
		information and relevant documents; file the modification application
		electronically; receive official communications and notifications from the
		Delegation or Subdelegation of the Government handling your case; and file
		additional documents and information electronically throughout the duration
		of the procedure.
	</p><br/>
	<p>
		Please note that{" "}
		<strong>
			this pack is not intended for modifications from student stay to residence
			and employment (HI-65) or for any other modification conceivable.
		</strong>
	</p><br/>
	<p>
		Modifications must be filed no earlier than sixty (60) calendar days prior
		to, and no later than ninety (90) calendar days after, expiration of the
		stay you’re trying to modify. (Note: applicants trying to make use of Royal
		Decree 557/2011 must file before 20 May 2025).
	</p><br/>
	<p>
		These “Special Terms of Service” (“Special Terms”) govern your use of the
		aforementioned service pack. Please refer to the General Terms and
		Conditions (“General Terms”). These Special Terms coexist with the General
		Terms and all such Terms as are listed therein.
	</p>
	<Spacer />
	<h1 id="service-fee" className='secondary-title center-flex'>1. - Service Fee</h1>
	<Spacer />
	<p>
		The “Service Fee” for this service pack is two hundred fifty euros (250€).
		You agree to pay the Service Fee upon purchasing the service pack.
	</p>
	<Spacer />
	<h1 id="administrative-fees" className='secondary-title center-flex'>2. - Administrative Fee(s)</h1>
	<Spacer />
	<p>At the time of writing, HI-66 is subject to two Administrative Fees:</p><br/>
	<ul>
		<li>
			<p>
				For authorization to reside, Fee 790-052 2.1, in the amount of ten euros
				and ninety-four cents (10,94€) and
			</p>
		</li>
		<li>
			<p>
				For authorization to work, Fee 790-062 1.5, in the amount of two hundred
				three euros and eighty-four cents (203,84€).
			</p>
		</li>
	</ul><br/>
	<p>
		You may be exempt from Fee 790-062 1.5 if you’re a citizen of an
		Iberoamerican country, of the Philippines, of Andorra, or of Equatorial
		Guinea, if you’re a Sephardic Jew, or if you’re the child or grandchild of a
		natural Spanish citizen. To benefit from this exemption, you must provide
		evidence of falling into one of these categories.
	</p><br/>
	<p>
		Both fees can be paid by Continentalis on your behalf. You may thus opt to
		have us do so upon purchasing your service pack or at any point prior to
		filing your case.
	</p>
	<Spacer />
	<h1 id="administrative-representation" className='secondary-title center-flex'>3. - Administrative Representation</h1>
	<Spacer />
	<p>
		This procedure may be filed by a Qualified Representative without
		necessarily needing a formal Power of Administrative Representation. You
		hereby authorize Continentalis to select a Qualified Representative to file
		your case in accordance with the General Terms.
	</p><br/>
	<p>
		If the relevant Delegation or Subdelegation of the Government requires it,
		we’ll arrange for you to issue Continentalis and/or its Qualified
		Representatives with a Power of Administrative Representation signed through
		our third-party identity certifier, Docuten, at no additional cost to you.
	</p><br/>
	<h1 id="business-plan" className='secondary-title center-flex'>4. - Business Plan</h1>
	<Spacer />
	<p>
		Applications for modification from student stay to residence and
		self-employment may require, among other documents, a viable business plan.
		If you wish for Continentalis to draft a business plan and obtain a
		viability report for your plan, you may purchase a Business Plan service
		pack using the Continentalis App. As a User of this modification service
		pack, we’re happy to give you a ten percent 10% discount on the Business
		Plan service pack.
	</p><br/>
	<h1 id="communications" className='secondary-title center-flex'>5. - Communications</h1>
	<Spacer />
	<p>
		You expressly authorize us to send you periodic notices of time left until
		entry into force of Royal Decree 1155/2024.
	</p><br/>
	<h1 id="term-and-completion" className='secondary-title center-flex'>6. - Term and completion</h1>
	<Spacer />
	<p>The Term for this Service is the earlier of the following:</p><br/>
	<ul>
		<li>
			<p>
				Notification of a FAVORABLE resolution, granting modification from stay
				to residence and self-employment;
			</p>
		</li>
		<li>
			<p>
				Notification of a resolution, whether favorable or not, resolving any
				administrative appeals you lodge in relation to your case, whether or
				not you lodge the appeal through Continentalis;
			</p>
		</li>
		<li>
			<p>
				Filing a lawsuit (contentious-administrative appeal) regarding either of
				the above;
			</p>
		</li>
		<li>
			<p>A lapse of:</p>
			<ul>
				<li>
					<p>
						Six (6) months from the date of purchase of this service pack, if
						you’ve not submitted your case or
					</p>
				</li>
				<li>
					<p>
						Eighteen (18) months from the date on which you file your case; or
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p>The entry into force of Royal Decree 1155/2024.</p>
		</li>
	</ul><br/>
	<p>
		Without prejudice to your Right to Withdraw, should you not file your case
		prior to entry into force of Royal Decree 1155/2024,{" "}
		<strong>you will not be entitled to any refunds.</strong>
	</p><br/>
	<Spacer />
	<div className='indent'>
		<img src="/joanneSignature.png" />
	</div>
	<Spacer25 />
	<p className='basic-flex indent bold'>{ln.jpoManagingParter}</p>
	<Spacer100 />

</div></div></div></div>
	);
}

export function TermsOfServiceGeneralInitAccount() {
	return(
<div>
<div className='center-flex'>
	<div className='document'>
	<div className='p animated-div'>
	<Spacer />
	<h1 id='title' className='primary-title centered-text'>General Terms of Service</h1>
	<Spacer />
	<p>24 March 2025</p>
	<h1 id="introduction" className='secondary-title center-flex'>0. - Introduction</h1>
	<Spacer />
	<p className='larger-font'><i>(Sorry you have to "read" this. The accept button's at the bottom)</i></p><br />
	<p className='basic-flex'>
		Thanks for using Continentalis App! Before you can start using Continentalis
		App, we have to get some formalities out of the way, starting with these
		General Terms of Service (“General Terms”). We’ve just launched and these
		General Terms are still being polished, but…
	</p><br/>
	<p>
		These General Terms, along with any applicable Additional Terms indicated
		below (collectively, the “Terms”), cover your use and access to the
		products, services, software, platform, and websites (collectively, the
		“Services”) provided by Continental Immigration Services, S.L., and any of
		our affiliates (collectively, “Continentalis”).
	</p><br/>
	<p>
		By using our Services, you agree to be bound by the Terms, by the terms and
		conditions set forth in our Legal Notice and Privacy Policy.
	</p><br/>
	<p>
		If you’re using our Services as the employee or agent of an organization,
		you’re agreeing to the Terms on behalf of said organization.
	</p><br/>
	<p>
		You must be the legal age of majority in your jurisdiction of residence or
		otherwise able to enter into a binding contract with Continentalis in order
		to use the Services. In no event is the use of our Services permitted by
		persons under the age of fourteen (14).
	</p><br/>
	<p>
		In addition to these General Terms, your use of our Services may be governed
		by additional terms and conditions, to which we’ve alluded, such as
		Continentalis’s:
	</p><br/>
	<ul>
		<li>
			<p>Legal Notice</p>
		</li>
		<li>
			<p>Privacy Policy, and</p>
		</li>
		<li>
			<p>Cookie Policy.</p>
		</li>
	</ul>
	<br/>
	<p>
		In addition to the terms and conditions enumerated above, Additional Terms
		shall include any special contracts you enter into with Continentalis
		pertaining to specific Services, whether offered directly on the App Site or
		through other Continentalis channels.
	</p><br/>
	<p>
		In case of conflict between the General Terms and the Additional Terms, then
		the Additional Terms govern in relation to the respective subject matter or
		Service. Certain Services are performed by affiliates or subsidiaries of
		Continental Immigration Services, S.L., where noted in the applicable
		Additional Terms.
	</p><br/>
	<Spacer />
	<h2 id="general-information" className='tertiary-title center-flex'>0.1. - General Information</h2>
	<Spacer />
	<p>
		<strong>Name:</strong> Continental Immigration Services, S.L.,
		(“Continentalis”)
	</p>
	<p>
		<strong>NIF:</strong> B13746680
	</p>
	<p>
		<strong>Address:</strong> Calle de la Princesa 31, 2.º-2, 28008 Madrid,
		Spain
	</p>
	<p>
		<strong>Phone number:</strong> Look at the bottom of the page
	</p>
	<p>
		<strong>Email address:</strong> info@continentalis.eu
	</p>
	<p>
		<strong>Registration Data:</strong> Mercantile Registry of Madrid, T 45.275,
		F 160, S 8, H M-796.481.
	</p>
	<p>
		Continentalis is considered a “commercial entity” (“
		<em>entidad mercantil</em>,” “<em>empresario</em>”) under Spanish law.
	</p>
	<Spacer />

	<h1 id="access-and-use" className='secondary-title center-flex'>1. - Access and use</h1>
	<Spacer />

	<h2 id="eligibility-to-use" className='tertiary-title center-flex'>1.1. - Eligibility to use</h2>
	<Spacer25 />
	<p>
		You have to be at least eighteen (18) years old and be capable of entering
		into a binding agreement to use the Continentalis App. By agreeing to these
		General Terms, you’re warranting and representing that you meet these
		requirements.
	</p>
	<Spacer25 />
	<h3 id="limited-right-to-use" className='quad-title'>1.1.1. - Limited right to use</h3>
	<Spacer25 />
	<p>
		By accepting these General Terms, you’re agreeing to access the Services for
		your personal use and, as the case may be, for your dependent family members
		or Represented Persons, and only as expressly provided in the Terms.
	</p><br/>

	<p>
		You’re not allowed to use the App Site if you’re an attorney, procurator,
		administrative agent (“<em>gestor administrativo</em>”), social graduate,
		immigration consultant, or other similar professional acting in that
		capacity, unless expressly authorized by Continentalis.
	</p><br/>
	<p>
		Violations of these restrictions may result in immediate termination of your
		access to the Services and may result in a claim for damages due to
		infringement.
	</p><br/>
	<h3 id="availability-and-stability" className='quad-title'>1.1.2. - Availability and stability</h3><br/>
	<p>
		Continentalis App is accessible on the WWW at app.continentalis.eu (the “App
		Site”). Like any web-based service, we may have downtime or service
		interruptions. We’ll endeavor to ensure that Continentalis App is up and
		running on the App Site as stably as possible; if we need to interrupt the
		Continentalis App in order to update it, we’ll notify Users ahead of time
		—except for emergencies, at least twenty-four (24) hours ahead of time. You
		agree not to hold us responsible for reasonable downtime and interruptions.
	</p><br/>
	<p>
		Our lawyer wants us to say that his fancy degrees are only good for Spanish
		and European legislation. We don’t know if our Site is in compliance with
		laws where you, the User, are accessing the Site—unless you’re accessing it
		in Spain. If you’re not accessing our Site from within Spain, you may be
		violating the laws of your host state. If accessing our Site is illegal
		where you are, perhaps consider moving. You deserve better. In any case, you
		agree not to hold us liable if accessing the App Site is illegal where you
		live.
	</p><br/>
	<h2 id="modifications" className='tertiary-title center-flex'>1.2. - Modifications</h2><br/>
	<p>
		We reserve the right to modify these Terms, including, but not limited to
		changing, deleting, or supplementing the Terms with Additional Terms
		(collectively, “Changes”) at our sole discretion. We’ll update the Terms in
		their consolidated versions, as well as summaries of Changes to the App
		Site.
	</p><br/>
	<p>
		Make sure to review the Terms on the App Site and on our general site
		—continetnalis.eu— on a regular basis to stay current on our terms and
		conditions. Except where the law requires us to obtain explicit consent,
		your continued use of the App Site and the Services after the Changes take
		effect mean you’ve agreed to the Changes tacitly. You agree not to hold us
		liable to you or anyone else for the Changes.
	</p><br/>
	<h2 id="communications" className='tertiary-title center-flex'>1.3. - Communications</h2><br/>
	<h3 id="communications-generally" className='quad-title'>1.3.1. - Communications generally</h3><br/>
	<p>
		You agree to let us send you communications in connection with Continentalis
		App and the App Site, including, but not limited to, communications
		providing you information related to your Services, notices of official
		communications or notifications related to your active cases ready to be
		accessed, notices of deadlines to accessing official communications or
		notifications related to your active cases, notices of status updates
		related to your active cases, and notices of submission errors or other
		technical incidents related to your active cases or cases pending
		submission, via electronic means, including by e-mail, SMS, in-App Site
		notifications, or push notifications on Continentalis mobile apps
		(collectively, “Communications”).
	</p><br/>
	<p>
		If you agree, we’ll also send you marketing and promotional communications
		regarding Continentalis and our Services, which’ll be included in
		“Communications.” Don’t worry, we won’t bombard you with spam and you can
		opt out of marketing and promotional communications sent to you by
		unsubscribing using the “Unsubscribe” at the bottom of the communication.
	</p><br/>
	<p>
		You agree that Communications satisfy any legal requirements that
		communications be made in writing.
	</p><br/>
	<p>
		We’re acting as an intermediary between government agencies and you:
		<strong> this is serious stuff</strong>. It’s on you to keep your contact
		details current and to check in for Communications on the App Site.
	</p><br/>
	<p>
		If you elect to receive and/or send communications or other messages with
		Continentalis or the App Site by SMS, you confirm that you are the
		subscriber of the mobile service for the mobile number you provide to us or
		that you are otherwise authorized by the subscriber to receive SMS
		communications at said mobile number. You can’t blame us for any issues,
		including, but not limited to failure of delivery, delays in transmission,
		or service outages related to SMS. The costs derived from the use of SMS are
		your responsibility.
	</p><br/>
	<h3 id="communications-regarding-institutional-public-sector-communications-and-notifications" className='quad-title'>
		1.3.2. - Communications regarding Institutional Public Sector communications
		and notifications
	</h3><br/>
	<p>
		The Continentalis App acts as an interface between you and the Government of
		the Kingdom of Spain, a government of a Spanish Autonomous Community, a
		government of a Province, a government of a Municipality in Spain, or any of
		the agencies or organisms pertaining to the aforementioned governments
		(collectively, the “Institutional Public Sector”).
	</p><br/>
	<p>
		During an administrative process underway with an entity of the
		Institutional Public Sector, the entity may send you communications and
		notifications.
	</p><br/>
	<p>
		As a general rule, communications and notifications sent to you by an entity
		of the Institutional Public Sector{" "}
		<strong>must be accessed within ten (10) calendar days</strong> of the
		entity making the communication or notification accessible to you; should
		you not access the communication or notification within the aforementioned
		term, the Institutional Public Sector entity may deem that you have refused
		the communication or notification. Without prejudice to any features of the
		App Site allowing automatic communication and notification access at the end
		of ten days since a communication or notification is made available,
		<strong>
			you agree to access communications and notifications within the
			aforementioned term. You also agree to hold Continentalis blameless if you
			don’t access communications or notifications on time and you’ve not opted
			for us to access these on your behalf on the tenth day.
		</strong>
	</p><br/>
	<p>
		Deadlines to react to certain Institutional Public Sector communications and
		notifications start to run once you have accessed or, as the case may be,
		refused the communication or notification.
	</p><br/>
	<p>
		General rules are superseded by special rules applicable to specific
		administrative procedures. Talk to a lawyer to determine the deadlines
		applicable to your procedure.
	</p><br/>
	<h1 id="ownership" className='secondary-title center-flex'>2. - Ownership</h1>
	<Spacer25 />
	<h2 id="intellectual-property" className='tertiary-title center-flex'>2.1. - Intellectual property</h2><br/>
	<p>Refer to “Intellectual Property Rights” on our Legal Notice.</p><br/>
	<h2 id="downloadable-content" className='tertiary-title center-flex'>2.2. - Downloadable content</h2><br/>
	<p>
		Continentalis may make certain digital assets available for download in PDF,
		DOCX, EPUB, or other formats. Except as expressly agreed in writing, making
		these digital assets available for download does not constitute granting,
		conveying, transferring, or assigning rights to the digital assets. You
		agree to use the digital assets only as intended —and as indicated in each
		digital asset or its hosting page— and never for commercial or professional
		purposes. Continentalis reserves the right to seek civil and/or criminal
		remedies for unauthorized use of its digital assets.
	</p><br/>
	<h2 id="user-submitted-content" className="tertiary-title center-flex">2.3. - User-Submitted Content</h2><br />
	<h3 id="submissions" className='quad-title'>2.3.1. - Submissions</h3><br/>
	<p>
		The App Site may enable you to submit, post, upload, or otherwise make
		available content such as questions, public messages, ideas, product
		feedback,comments, and other content (collectively, “User-Submitted
		Content”).
	</p><br/>
	<p>
		Except as expressly agreed in writing, you grant us a nonexclusive,
		royalty-free, and fully sublicensable right to access, view, use, reproduce,
		adapt, public, translate, create derivative works from, distribute, copy,
		and display your User-Submitted Content throughout the world in any form,
		medium, or technology now known or later developed. You represent and
		warrant that: (a) you own or otherwise control all of the rights to the
		User-Submitted Content; (b) your User-Submitted Content is truthful and
		accurate; and (c) the User-Submitted Content does not infringe the Terms or
		any applicable legislation.
	</p><br/>
	<p>
		Use-Submitted Content shall not be construed to include the User’s personal
		documents, such as, but not limited to, passports and other identification
		documents, birth certificates, marriage certificates, business plans,
		financial statements, photographs, or other user-generated documents
		uploaded to the User’s documents repository or to the User’s cases, or any
		documents generated by the Continentalis App account environment.
	</p><br/>
	<h3 id="screening-and-removal" className='quad-title'>2.3.2. - Screening and removal</h3><br/>
	<p>
		You agree that Continentalis may, at our sole discretion, pre-screen or
		remove User-Submitted Content, but that we have no obligation to do so.
		Continentalis reserves the right to remove any User-Submitted Content that
		violates the Terms or is objectionable in our sole discretion.
	</p><br/>
	<h1 id="restrictions" className='secondary-title center-flex'>3. - Restrictions</h1>
	<Spacer25 />
	<p>
		By using the App Site, you specifically agree not to, and to not permit
		others to, engage in, or attempt to engage in, any activity or transmit any
		information that, in our sole discretion:
	</p><br/>
	<ol type={1}>
		<li>
			<p>
				Violates any law or regulation applicable in the Kingdom of Spain and in
				your place of residence therein, or, in lieu thereof, applicable in
				Madrid;
			</p>
		</li>
		<li>
			<p>
				Advocates illegal activity or discusses illegal activity with the intent
				to commit said illegal activity;
			</p>
		</li>
		<li>
			<p>
				Violates Continentalis and any third-party rights, including, but not
				limited to, rights of privacy, publicity, copyright, trademark, patent,
				or trade secret;
			</p>
		</li>
		<li>
			<p>
				Is threatening, abusive, harassing, tortious, indecent, defamatory,
				sexually explicit or pornographic, discriminatory, vulgar, profane,
				obscene, libelous, constitutive of hate speech, violent, inflammatory,
				or otherwise objectionable;
			</p>
		</li>
		<li>
			<p>Interferes with any other person’s use of the App Site;</p>
		</li>
		<li>
			<p>Attempts to impersonate another person or entity;</p>
		</li>
		<li>
			<p>
				Falsely states, misrepresents, or conceals your affiliation with another
				person or entity;
			</p>
		</li>
		<li>
			<p>
				Distributes computer viruses or other malicious code, files, or programs
				which interrupt, destroy, or limit the functionality of any computer
				software or hardware or electronic communications equipment;
			</p>
		</li>
		<li>
			<p>
				Interferes with, disrupts, or disables the functionality or use of the
				App Site or any of its features;
			</p>
		</li>
		<li>
			<p>
				Hacks or accesses without authorization any feature or area of the App
				Site, especially, but not limited to, the account areas of any other
				User;
			</p>
		</li>
		<li>
			<p>
				Decompiles, reverse engineers, disassembles, or otherwise attempts to
				derive source code from the App Site, except as expressly permitted by
				the Terms or by law or by express written consent from Continentalis;
			</p>
		</li>
		<li>
			<p>
				Removes, disables, damages, circumvents, or otherwise interferes with
				security features of, or features that enforce limitations on, the App
				Site;
			</p>
		</li>
		<li>
			<p>
				Constitutes “screen scraping,” “database scraping,” or any other such
				activity with the purpose of obtaining lists of Users or other
				information;
			</p>
		</li>
		<li>
			<p>
				Downloads, distributes, posts, transmits, reproduces, broadcasts,
				duplicates, or otherwise uses Continentalis’s intellectual property
				except as expressly authorized; or
			</p>
		</li>
		<li>
			<p>
				Uses, or allows third parties to use, the App Site’s front-end and
				back-end contents, architectures, etc., to directly or indirectly
				create, train, test, implement, or otherwise feed any machine learning
				algorithm or artificial intelligence system except as expressly
				authorized by Continentalis.
			</p>
		</li>
	</ol>
	<br/>
	<p>Remember, be a good User.</p><br/>	
	<h1 id="usage-and-access-rights" className='secondary-title center-flex'>4. - Usage and access rights</h1>
	<Spacer25 />
	<h2 id="right-to-use-services" className='tertiary-title center-flex'>4.1. - Right to use Services</h2><br/>
	<p>
		Subject to these Terms, you have a limited, non-exclusive, non-transferable
		right and license during the Term to:
	</p><br/>
	<ol type="a">
		<li>
			<p>Use the Services you have purchased from Continentalis;</p>
		</li>
		<li>
			<p>
				Implement, configure, access, and use the Services you have purchased up
				to any applicable limits set forth in your specific Service
				agreement(s); and
			</p>
		</li>
		<li>
			<p>
				Access and use guides, samples, and similar digital assets made
				available for view or download on the App Site, solely for the purposes
				of learning about the App Site and the Services which you have
				purchased.
			</p>
		</li>
	</ol><br/>
	<p>
		Violation by you, or by anyone in use of your account, of the license
		provisions contained in this Section may result in the immediate termination
		of your right to use the Services, as well as potential civil and/or
		criminal liability.
	</p><br/>
	<h2 id="user-obligations" className='tertiary-title center-flex'>4.2. - User obligations</h2><br/>
	<p>
		Users are responsible for all use of the Services associated with their
		respective accounts. Users are solely responsible for maintaining
		confidentiality of their respective account usernames and passwords. Users
		agree to immediately notify Continentalis of any unauthorized access or use
		of the User’s respective account. Users agree to hold Continentalis
		blameless for any losses incurred as a result of other Users’ accounts,
		except to the extent that such liability cannot be lawfully excluded under
		applicable law.
	</p><br/>
	<h2 id="user-representation" className='tertiary-title center-flex'>4.3. - User representation</h2><br/>
	<p>
		Users may use the contracted Services in representation of other natural
		persons, provided said Users act in legal representation, curatorship, or a
		similar relationship with the other natural persons (“Represented Persons”).
		“Legal representation” shall mean representation established in law, as for
		parents, guardians, or, in civil law jurisdictions, tutors; “legal
		representation” shall not mean representation established in a power of
		attorney or mandate.
	</p><br/>
	<Spacer25 />
	<h1 id="payment-terms" className="secondary-title center-flex">5. - Payment terms</h1>
	<Spacer25 />
	<h2 id="service-fees" className='tertiary-title center-flex'>5.1. - Service fees</h2><br/>
	<p>
		The Services offered on Continentalis App are subject to payment of service
		fees, as set forth and quantified in each Service’s specific terms and
		conditions.
	</p><br/>
	<p>
		Continentalis reserves the right to modify service fees at any time.
		Purchases made prior to such modifications in service fees shall not be
		affected by said modifications.
	</p><br/>
	<h2 id="administrative-fees" className='tertiary-title center-flex'>5.2. - Administrative Fees</h2><br/>
	<h3 id="applicability-of-administrative-fees" className='quad-title'>
		5.2.1. - Applicability of Administrative Fees
	</h3><br/>
	<p>
		Certain administrative procedures require payment of administrative fees
		(referred to in Spanish as “<em>tasas administrativas</em>”) or rates
		(referred to in Spanish as “<em>tarifas</em>”) (collectively,
		“Administrative Fees”). In some cases, payment of Administrative Fees must
		be made <strong>prior</strong> to submission of an administrative
		application or petition; in other cases, payment of Administrative Fees may
		be made at a later date.
	</p><br/>
	<p>
		If you don’t pay Administrative Fees, the government may bar submission of
		your application or petition, or they may dismiss or deny your application
		or petition, or the government may carry out administrative actions
		requiring payment, and even exacting payment, of Administrative Fees,
		potentially causing delays in processing and generating additional costs.
	</p><br/>
	<h3 id="payment-of-administrative-fees-in-representation" className='quad-title'>
		5.2.2. - Payment of Administrative Fees in representation
	</h3><br/>
	<p>
		In some cases, we may be able to pay Administrative Fees on your behalf.
		We’ll make this option available where the government allows it. In these
		cases, before we pay the Administrative Fee on your behalf, we’ll require
		that you provide us the funds needed to pay the Administrative Fee, plus a
		5% surcharge to account for effort exerted and costs incurred by
		Continentalis.
	</p><br/>
	<p>
		If you elect to have us pay Administrative Fees on your behalf, or on your
		Represented Persons’ behalf, it’s on you to provide us correct information,
		including, but not limited to, procedure time,
		<em>justificante</em> number if you already have one, the creditor agency,
		the debtor, etc., so that we can generate an adequate payment form. You
		agree not to hold us liable for errors in the information you provide for
		this service.
	</p><br/>
	<p>
		Our system will attempt to pay the Administrative Fee as soon as you’ve
		authorized it to. Once paid, you won’t be able to ask us for a refund. If a
		refund is desired, you’ll need to request a refund from the appropriate
		State agency. The 5% surcharge is not refundable, as it covers immediate
		work and costs.
	</p><br/>
	<h2 id="promotional-codes" className='tertiary-title center-flex'>5.3. - Promotional codes</h2><br/>
	<p>
		We may, from time to time, offer promotional codes for use with a Service.
		These codes are only valid for initial engagements of the specific Service
		—e.g., for your first “Modification from Student Stay to Residence and
		Self-Employment” pack— unless otherwise specified. By “your” first, we
		really mean “your” first: we’ll use your NIE and biographical information to
		ensure that you’re not double-dipping. Be a good User.
	</p><br/>
	<h2 id="refunds" className='tertiary-title center-flex'>5.4. - Refunds</h2><br/>
	<p>
		You acknowledge and agree that payments are non-refundable except as
		expressly provided in these Terms or as otherwise agreed to in writing by
		Continentalis or as required by applicable legislation. Charges for Services
		and for payment of Administrative Fees will be billed to the User in
		advance.
	</p><br/>
	<Spacer25 />
	<h1 id="administrative-representation" className='secondary-title center-flex'>6. Administrative representation</h1>
	<Spacer25 />
	<h2 id="capacity" className='tertiary-title center-flex'>6.1. - Capacity</h2><br/>
	<p>
		The User warrants and represents that the User possesses sufficient capacity
		to enter into administrative procedures pursuant to Law 39/2015, of 1
		October, on the Common Administrative Procedure of the Public
		Administrations (“LCAPPA”).
	</p><br/>
	<p>
		The User warrants that they are entering into administrative procedures on
		their own behalf or on behalf of their Represented Persons in accordance
		with the provisions of LCAPPA.
	</p><br/>
	<p>
		The User agrees that they, or their legal representatives, curators, or, in
		civil law jurisdictions, tutors, will notify Continentalis of any changes to
		the User’s, or the User’s Represented Persons’, capacity within ten (10)
		calendar days of the change.
	</p><br/>
	<h2 id="representation" className='tertiary-title center-flex'>6.2. - Representation</h2><br/>
	<p>
		The User acknowledges that Continentalis has informed them that LCAPPA
		authorizes interested parties to engage in administrative procedures on
		behalf and in representation of third parties (“Administrative
		Representation”), and that Administrative Representation is voluntary for
		persons with capacity.
	</p><br/>
	<h3 id="powers-of-administrative-representation" className='quad-title'>
		6.2.1. - Powers of Administrative Representation
	</h3><br/>
	<p>
		In accordance with LCAPPA, Administrative Representation requires issuance
		of Powers of Administrative Representation in a public document or in a
		document signed with a recognized digital signature and recorded with the
		Government of Spain’s Electronic Registry of Powers (“
		<em>Registro Electrónico de Apoderamientos</em>”).
	</p><br/>
	<p>
		The User acknowledges that the correct performance of the Terms by
		Continentalis and its affiliates requires Powers of Administrative
		Representation and, therefore, warrants and represents as follows:
	</p><br/>
	<ol type="a">
		<li>
			<p>
				That the User grants Continentalis and its attorney, procurator,
				administrative agent, social graduate, and other agents, at
				Continentalis’s discretion,{" "}
				<strong>
					general powers of administrative representation for any administrative
					procedure before any public administration or other Institutional
					Public Sector entity
				</strong>
				;
			</p>
		</li>
		<li>
			<p>
				That the duration of the User’s grant of power of Administrative
				Representation shall be for the period selected by the User, to be at
				least <strong>six (6) months</strong> from the date of issuance;
			</p>
		</li>
		<li>
			<p>
				That the default duration of the User’s grant of power of Administrative
				Representation, in lieu of a duration specified by the User, shall be
				the statutorily-established period of five (5) years from the date of
				issuance;
			</p>
		</li>
		<li>
			<p>
				That Continentalis and its attorney, procurator, administrative agent,
				social graduate, and other agent affiliates may renounce representation
				in accordance with these Terms; and
			</p>
		</li>
		<li>
			<p>
				That the User shall sign a qualified power of Administrative
				Representation within five (5) business days from such date as
				Continentalis shall require the User to that effect.
			</p>
		</li>
	</ol><br/>
	<p>
		Each Service pack’s Service Fees purchased through Continentalis App shall
		include the electronic signing of a qualified power of attorney for
		recording with the Electronic Registry of Powers through Continentalis’s
		third-party identity certifiers of choice. The User must provide correct
		personal details and identifying documents for the drawing up of the power
		of attorney.{" "}
		<strong>
			If the User has an active power of Administrative Representation already
			in place and at least six (6) months remain in its validity, this
			provision shall not apply; where an administrative term established for a
			new case exceeds the duration of the User’s active power of attorney, the
			provision shall apply.
		</strong>
	</p><br/>
	<p>
		Fees for notarial powers of Administrative Representation shall not be
		deemed included in the Service Fees.
	</p><br/>
	<h3 id="presumed-administrative-representation" className='quad-title'>
		6.2.2. - Presumed Administrative Representation
	</h3><br/>
	<p>
		Certain procedures, such as immigration applications filed with Delegations
		and Subdelegations of the Government, as well as citizenship applications
		filed through the various Colleges of Attorneys, benefit from presumed
		Administrative Representation.
	</p><br/>
	<p>
		The User hereby requests that Continentalis default to presumed
		Administrative Representation where possible, by filing applications and
		petitions through qualified attorney, procurator, administrative agent, or
		social graduate selected at Continentalis’s sole discretion from
		Continentalis’s pool of Qualified Representatives.
	</p><br/>
	<p>
		The User warrants and represents that they are aware that, despite the
		presumption of Administrative Representation here described, public
		administrations and other Institutional Public Sector entities may, in
		exceptional and reasoned writs, demand proof of issuance of powers of
		Administrative Representation. In such cases, the User agrees to act in
		accordance with section 7.2.1.
	</p><br/>
	<h3 id="qualified-representatives" className='quad-title'>6.2.3. - Qualified Representatives</h3><br/>
	<p>
		Continentalis will maintain a pool of attorneys, procurators, administrative
		agents, and/or social graduates who have been authorized to represent
		natural or legal persons in administrative parties in accordance with
		article 5.7 LCAPPA (“Qualified Representative(s)”).
	</p><br/>
	<p>
		The User expressly authorizes Continentalis to, where possible, file the
		User’s applications through a Qualified Representative from the
		aforementioned pool, to be selected at Continentalis’s sole discretion.
	</p><br/>
	<h3 id="obligations-and-limitations-as-to-qualified-representatives" className='quad-title'>
		6.2.4. - Obligations and limitations as to Qualified Representatives
	</h3><br/>
	<p>
		In filing through a Qualified Representative, the User warrants and
		represents that the documents and information provided by the User in the
		relevant case are true and correct to the best of the User’s knowledge. The
		User further acknowledges that misrepresentations by the User and filing
		frivolous cases may result in administrative or professional actions against
		the Qualified Representative, including, but not limited to, removal from
		the public administrations’ and Institutional Private Sector entities’ rolls
		of qualified representatives. In the event that a Qualified Representative
		is sanctioned in the terms set forth in this paragraph due to
		misrepresentations by the User or due to filing of frivolous cases by the
		User, the User shall be liable to the Qualified Representative in an amount
		equal to the harms caused to the Qualified Representative, or five hundred
		euros (500€), whichever is greater.{" "}
		<strong>
			Be a good User: don’t have our Qualified Representatives struck off.
		</strong>
	</p><br/>
	<p>
		You alone are responsible for the accuracy, validity, and veracity of the
		data and documents lodged in any given administrative procedure filed using
		Continentalis App. Continentalis’s Qualified Representatives make no
		warranty of accuracy, validity, or veracity.
	</p><br/>
	<p>
		Administrative Representation in accordance with article 5.7 LCAPPA, in
		accordance with governing agreements between public administrations and
		professional associations, and in accordance with the Terms
		<strong>
			do not constitute an attorney-client, or other professional-client
			relationship between the User and the Qualified Representative, and do not
			constitute an obligation by the Qualified Representative to provide the
			User with legal advice.
		</strong>{" "}
		Without prejudice to the foregoing, privilege applies.
	</p><br/>
	<Spacer25/>
	<h1 id="personal-data-protection" className='secondary-title center-flex'>7. Personal Data Protection</h1>
	<Spacer25 />
	<p>
		You acknowledge your understanding and hereby provide consent that the
		information you provide to us or that we will collect will be processed as
		described in our Privacy Policy, available here:{" "}
		<a href="https://continentalis.eu/privacy-policy/">
			<u>https://continentalis.eu/privacy-policy/</u>
		</a>
		.
	</p><br/>
	<Spacer />

	<h1 id="confidentiality" className='secondary-title center-flex'>8. Confidentiality</h1>
	<Spacer/>
	<h2 id="scope" className='tertiary-title center-flex'>8.1. - Scope</h2><br/>
	<p>“Confidential Information” means:</p><br/>
	<ol type="a">
		<li>
			<p>
				Any written information, materials, and other documents supplied by
				Continentalis related to the App Site which we do not generally disclose
				publicly;
			</p>
		</li>
		<li>
			<p>
				Any written information, materials, and other documents supplied by you
				in relation to the Services;
			</p>
		</li>
		<li>
			<p>
				Any documents generated through the App Site for use in relation with
				the Services;
			</p>
		</li>
		<li>
			<p>
				Any Communications, except promotional and marketing Communications,
				sent to you by Continentalis in accordance with these Terms; and
			</p>
		</li>
		<li>
			<p>
				In general, any information which, by its nature, is deemed to be
				confidential <strong>and</strong> comes to be known by Continentalis by
				way of the Services.
			</p>
		</li>
	</ol><br/>
	<h2 id="restricted-use-and-professional-secrecy">
		8.2. - Restricted use and professional secrecy
	</h2><br/>
	<p>
		Continentalis shall, to the best of its ability, and to the extent required
		by applicable law, guarantee the security of Confidential Information on its
		servers, platform, website, etc.
	</p><br/>
	<p>
		Continentalis’s security measures are only as strong as the weakest element
		in the measures. To that end, the User agrees:
	</p><br/>
	<ol type="a">
		<li>
			<p>
				To establish a strong password in accordance with the password policy
				which shall be communicated on the App Site;
			</p>
		</li>
		<li>
			<p>To secure their passwords in accordance with good practices;</p>
		</li>
		<li>
			<p>To sign into their account only on trusted devices;</p>
		</li>
		<li>
			<p>
				To not leave their account open on any devices other than their own; and
			</p>
		</li>
		<li>
			<p>
				In general, to treat their account and documents uploaded thereto with
				care.
			</p>
		</li>
	</ol><br/>
	<p>
		Even where professional privilege —e.g., attorney-client privilege— is not
		in effect, Continentalis is subject to professional secrecy. Professional
		secrecy means that Continentalis cannot disclose your Confidential
		Information to any party, including, but not limited to, law enforcement
		agencies, courts, or administrative agencies, without your consent or
		without compulsory orders made in accordance with legislation.
	</p><br/>
	<h3 id="required-disclosure" className='quad-title'>8.2.1. - Required disclosure</h3><br/>
	<p>
		To the fullest extent possible, Continentalis shall reject any requests to
		access any Confidential Information by third parties. Except as expressly
		forbidden by law, we will notify you of any and all requests to access your
		Confidential Information made by State actors
		<strong>prior to</strong> complying, where applicable, with said requests.
	</p><br/>
	<p>
		Continentalis is not a law-enforcement agency-friendly company. We will not
		comply with requests to access Confidential Information where the law does
		not require us to.
	</p><br/>
	<Spacer />
	<h1 id="term-and-termination" className="secondary-title center-flex">9. Term and Termination</h1>
	<Spacer />
	<h2 id="term" className='tertiary-title center-flex'>9.1. - Term</h2><br/>
	<p>
		These Terms, together with any Changes, are effective as of your acceptance
		thereof and until your use of the Services ceases or until your account has
		been deleted either by you or by Continentalis in accordance with the Terms
		(“Term”).
	</p><br/>
	<h2 id="termination-by-user" className='tertiary-title center-flex'>9.2. - Termination by User</h2><br/>
	<p>
		You may terminate your account at any time. If you wish to terminate, you
		must provide notice, as we may instruct on the App Site, on Continentalis’s
		website, or by written notification to Continentalis pursuant to our Legal
		Notice. Requests for termination made in writing, rather than through
		automated processes, may take up to ten (10) calendar days from receipt
		thereof to be processed.
	</p><br/>
	<p>
		You agree to update your or your Represented Persons’ contact information in
		the relevant account areas{" "}
		<strong>
			prior to requesting termination of your or your Represented Persons’
			accounts.
		</strong>{" "}
		You agree to hold Continentalis blameless for your omission of this
		obligation.
	</p><br/>
	<h2 id="effects-of-termination" className='tertiary-title center-flex'>9.3. - Effects of termination</h2><br/>
	<p>
		Upon termination, Continentalis and any of its affiliated attorneys,
		procurators, administrative agents, social graduates, or other collaborators
		as set forth in the Terms and, specifically, in the special terms and
		conditions for each Service, shall, within one business day,{" "}
		<strong>
			notify withdrawal of representation to the relevant Institutional Public
			Sector entity
		</strong>
		, and provide your or your Represented Persons’ contact information as
		listed in the User account area.
	</p><br/>
	<p>
		Termination while administrative procedures are ongoing may cause issues
		with your or your Represented Persons’ open cases, including, but not
		limited to, communications and notifications by Institutional Public Sector
		being sent to Continentalis and its affiliates or being published to the
		Official Bulletin of the State, mailed to your last known address, or mailed
		to the address listed on your Spanish ID, among others. You are solely
		responsible for providing an alternative mode of notification for future
		official communications and notifications regarding ongoing cases at the
		time of termination. You agree to hold Continentalis blameless for improper
		conveyance of communications or notifications by Institutional Public Sector
		entities after Continentalis has withdrawn representation.
	</p><br/>
	<p>Upon termination:</p><br/>
	<ol type="a">
		<li>
			<p>
				Any and all liabilities the User has accrued before the termination will
				survive;
			</p>
		</li>
		<li>
			<p>
				Any licenses and use rights granted to the User will immediately cease
				in accordance with these Terms; and
			</p>
		</li>
		<li>
			<p>
				Any obligations for Continentalis to provide further access to the App
				Site to the User shall terminate, except any such rights as are
				expressly provided in the Terms or in applicable legislation.
			</p>
		</li>
	</ol><br/>

		<Spacer />
	<h1 id="right-to-withdraw" className='secondary-title center-flex'>10. Right to Withdraw</h1>
		<Spacer />
	<p>
		In accordance with Spanish and European Union legislation, the User shall be
		able to withdraw from the Terms applicable to each Service engaged within{" "}
		<strong>fourteen (14) calendar days of purchase</strong>
		(“Withdrawal Period”), without needing to indicate the reason for withdrawal
		and without incurring any costs other than costs for expediting any aspect
		of the Service (“Right to Withdraw”).
	</p><br/>
	<p>
		You may not exercise this Right to Withdraw once you’ve accessed the Service
		and consented to starting its performance. (You’ll know: any time you create
		a new case, you’ll be required to pay a Service Fee and, subsequently, start
		the case).
	</p><br/>
	<p>
		In order to exercise their Right to Withdraw with regard to any particular
		Service purchased through Continentalis App,{" "}
		<strong>the User must communicate to Continentalis</strong> their clear and
		unequivocal wish to withdraw from the Service within the Withdrawal Period.
		Notifications for exercise of the Right to Withdraw shall be made in writing
		to{" "}
		<a href="mailto:info@continentalis.eu">
			<u>info@continentalis.eu</u>
		</a>{" "}
		and must include your username and your invoice number or Service ID.
		<strong>
			<u>Never</u>
		</strong>{" "}
		include your password in these communications. If we need additional
		information in order to verify your identity or clear up any questions
		regarding your wish to withdraw, we will contact you; the withdrawal request
		will be considered made on the day of notification, not the day on which we
		clear up any doubts.
	</p><br/>
		<Spacer/>

	<h1 id="warranties-and-disclaimers" className='secondary-title center-flex'>11. Warranties and disclaimers</h1><br/>
	<p>
		The Continentalis App and the App Site and any information we supply you are
		provided “as is” and “as available.” We’ve done our best to ensure that
		everything’s correct. We’ve consulted with Melcart Abogados on the
		legalities of each procedure. Nevertheless, you assume the risks of using
		the App Site. When in doubt about a document, requirement, etc., consult
		with a lawyer.
	</p><br/>
	<p>
		Continentalis is not a law firm. The information on Continentalis’s website
		and on the App Site should not be construed as legal advice.
		<strong>
			Consult with a lawyer wherever you have questions regarding deadlines,
			requirements, interpretations, etc.
		</strong>
	</p><br/>
				<Spacer />
				<div className='indent'>
					<img src="/joanneSignature.png" />
				</div>
				<Spacer25 />
				<p className='basic-flex indent bold'>{ln.jpoManagingParter}</p>
			<Spacer100 />
				</div>

</div>
</div></div>
	);
}
